"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const algorithm_1 = require("../algorithm");
const json_derived_field_1 = require("../../../parsers/json/json-derived-field");
class SimpleAlgorithm extends algorithm_1.Algorithm {
    constructor(simpleAlgorithmJson) {
        super(simpleAlgorithmJson);
        const derivedField = simpleAlgorithmJson.derivedFields.find(({ name }) => {
            return name === simpleAlgorithmJson.output;
        });
        if (!derivedField) {
            throw new Error(
            // tslint:disable-next-line:max-line-length
            `Constructing SimpleAlgorithm but no derived field with name ${simpleAlgorithmJson.name} found in JSON's derivedFields array`);
        }
        this.output = json_derived_field_1.parseDerivedFieldJsonToDerivedField(derivedField, simpleAlgorithmJson.derivedFields, []);
    }
    evaluate(data) {
        return this.output.calculateCoefficent(data, this.userFunctions, this.tables);
    }
}
exports.SimpleAlgorithm = SimpleAlgorithm;
//# sourceMappingURL=simple-algorithm.js.map